/**
 * this file configures the redux store setup
 *
 * the function configureStore is called from main.js to pass the `history`
 *
 * Created by Tom on 23/5/17
 */

import { createStore, applyMiddleware, compose } from 'redux'
//import { createLogger } from 'redux-logger'
import thunk from 'redux-thunk'
import createSagaMiddleware from 'redux-saga'
import { routerMiddleware } from 'react-router-redux'
import createHistory from 'history/createBrowserHistory'
import { responsiveStoreEnhancer } from 'redux-responsive'
import throttle from 'lodash/throttle'

import rootSaga from './sagas'
import { loadState, saveState } from './utility/localStorage'
import rootReducer from './reducers'

// create a history
export const history = createHistory()

// create middleware for the sagas
const sagaMiddleware = createSagaMiddleware()

// build the middleware for intercepting and dispatching navigation actions
const routingMiddleware = routerMiddleware(history)

// create the logger middleware
//const loggerMiddleWare = createLogger()

// create the middleware array
const middleware = [
    thunk,
    //loggerMiddleWare,
    routingMiddleware,
    sagaMiddleware
]

const enhancers = []

// ONLY FOR DEBUGGING
if (window.devToolsExtension) {
    // Chrome Redux DevTool extension
    enhancers.push(window.devToolsExtension())
}

// create the store
const store = createStore(
    rootReducer,
    loadState(),
    compose(
        responsiveStoreEnhancer,
        applyMiddleware(...middleware),
        ...enhancers
    )
)

// run the root saga
sagaMiddleware.run(rootSaga)

// sync with localstorage
// NOTE: we use the tiny library `throttle` from the package `lodash` that
// guarantees we don't sync to localStorage more than once per second
store.subscribe(throttle(()=>{
    // store the user data
    saveState({
        user: store.getState().user
    })
}, 1000))

// ONLY FOR DEBUGGING - ACCESS STORE IN CONSOLE window.store.dispatch()
// NOTE: change the execution environment in the Chrome console from the default <top frame> to <debuggerWorker.js>
//window.reduxStore = store

export default store



// WEBPACK FOOTER //
// ./src/store.js